import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Check } from 'lucide-react';
import Header from '../components/Header';
import { useLang } from '../context/LanguageContext';

const LoadingPage = () => {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [currentTask, setCurrentTask] = useState(0);
  const { t } = useLang();

  const tasks = [t('task1'), t('task2'), t('task3'), t('task4'), t('task5')];

  useEffect(() => {
    const total = 5500;
    const interval = 50;
    let elapsed = 0;
    const timer = setInterval(() => {
      elapsed += interval;
      const pct = Math.min(100, (elapsed / total) * 100);
      setProgress(pct);
      setCurrentTask(Math.min(tasks.length - 1, Math.floor((pct / 100) * tasks.length)));
      if (pct >= 100) {
        clearInterval(timer);
        setTimeout(() => navigate('/plan'), 400);
      }
    }, interval);
    return () => clearInterval(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0d0e10] text-white">
      <Header />
      <main className="px-4 md:px-8 py-10">
        <div className="max-w-md mx-auto text-center">
          <h1 className="heading-font text-3xl md:text-4xl font-black tracking-wide">
            {t('buildingPlan1')}<br />{t('buildingPlan2')}
          </h1>
          <p className="mt-4 text-white/70">{t('buildingPlanSub')}</p>

          <div className="relative w-48 h-48 mx-auto mt-10">
            <svg className="w-48 h-48 -rotate-90" viewBox="0 0 100 100">
              <circle cx="50" cy="50" r="45" fill="none" stroke="#1f2024" strokeWidth="6" />
              <circle
                cx="50"
                cy="50"
                r="45"
                fill="none"
                stroke="#ff4e15"
                strokeWidth="6"
                strokeLinecap="round"
                strokeDasharray={`${(progress / 100) * 283} 283`}
                style={{ transition: 'stroke-dasharray 0.1s linear' }}
              />
            </svg>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="heading-font text-4xl font-black">{Math.round(progress)}%</span>
            </div>
          </div>

          <div className="mt-10 space-y-2 text-left">
            {tasks.map((taskText, i) => {
              const done = i < currentTask || progress >= 100;
              const active = i === currentTask && progress < 100;
              return (
                <div
                  key={i}
                  className={`flex items-center gap-3 px-4 py-3 rounded-sm border transition-colors ${
                    done ? 'border-[#ff4e15]/40 bg-[#1a1b1e]' : active ? 'border-[#ff4e15] bg-[#1f1210]' : 'border-[#1f2024] bg-[#141518]'
                  }`}
                >
                  <span className={`w-6 h-6 rounded-full flex items-center justify-center shrink-0 ${
                    done ? 'bg-[#ff4e15]' : active ? 'bg-[#ff4e15]/20 border border-[#ff4e15]' : 'bg-[#1f2024]'
                  }`}>
                    {done ? (
                      <Check size={14} className="text-white" />
                    ) : active ? (
                      <span className="w-2 h-2 rounded-full bg-[#ff4e15] animate-pulse" />
                    ) : null}
                  </span>
                  <span className={`text-sm ${done || active ? 'text-white' : 'text-white/50'}`}>
                    {taskText}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </main>
    </div>
  );
};

export default LoadingPage;
